module.exports = __webpack_public_path__ + "img/laps-sjk.5ea81fcd.png";